import type { IntlShape } from "react-intl";

type RoleLabel = { code: string; name: string; isSystem: boolean };

export const STANDARD_ROLE_CODES = ["standard-administrators", "standard-verified", "standard-registered"] as const;

export function roleLabel(intl: IntlShape, role: RoleLabel): string {
  const id = `admin.role.${role.code}.name`;
  return (role.isSystem || isStandardRole(role)) && role.name === role.code && id in intl.messages
    ? intl.formatMessage({ id }) : role.name;
}

export function roleDescription(intl: IntlShape, role: RoleLabel & { description?: string | null }): string | null {
  const id = `admin.role.${role.code}.description`;
  if (isStandardRole(role) && role.description === role.code && id in intl.messages) return intl.formatMessage({ id });
  return role.isSystem && role.name === role.code && id in intl.messages ? intl.formatMessage({ id }) : role.description ?? null;
}

function isStandardRole(role: RoleLabel): boolean {
  return STANDARD_ROLE_CODES.some(code => code === role.code);
}

export function providedRoleOrder(role: RoleLabel): number {
  const standardIndex = STANDARD_ROLE_CODES.findIndex(code => code === role.code);
  if (standardIndex >= 0) return standardIndex;
  const index = (import.meta.env.VITE_PROVIDED_ROLE_CODES ?? "").split(",").map((code: string) => code.trim()).indexOf(role.code);
  return index < 0 ? Number.MAX_SAFE_INTEGER : STANDARD_ROLE_CODES.length + index;
}

export function isProvidedRole(role: RoleLabel): boolean {
  return providedRoleOrder(role) !== Number.MAX_SAFE_INTEGER;
}
